import { CircularProgress, Typography, Box, TextField, InputAdornment } from "@mui/material";
import Person from "@mui/icons-material/Person";
import { useNavigate } from "react-router-dom";
import { green } from "@mui/material/colors";
import { Info } from "@mui/icons-material";
import React, { useState } from "react";
import { useFormik } from "formik";
import "./forgot-password.scss";
import * as Yup from "yup";
import ApiClient from "helpers/ApiClient";

const FormInput: React.FC = () => {
  // ********************************************* STATES ****************************************

  const [loadingState, setLoadingState] = useState<any>(false);
  const [resetPass, setResetPass] = useState(true);
  const [error,setError]=useState("");

  const navigate = useNavigate();
  const validation = Yup.object().shape({
    email: Yup.string().required("Email is required").email("Enter a valid email"),
  });
  const initialSchema = { email: "" };

  // ******************************************* SUBMIT HANDLER ************************************
  const forgotPasswordHandler = async() =>{
        setLoadingState(true);
    ApiClient.post("users/forget-password", values).then((res) => {
        setLoadingState(false);
        setResetPass(false);
      })
      .catch((err) => {
        setLoadingState(false);
        setError(err?.response?.data?.message)
      });
  };

  const { values, touched, errors, handleChange, handleBlur, handleSubmit } = useFormik({
    initialValues: initialSchema,
    validationSchema: validation,
    onSubmit: forgotPasswordHandler,
  });

  //********************************************** LIST OF ALL REGISTERED USERS *************************************

  return (
    <>
      <Typography align="center" mt={6} mb={3} lineHeight="48px" fontSize={{ xs: "30px", md: "40px" }}>
        <span className="grey-color fw-500"> Reset Password </span>
      </Typography>
      {resetPass && (
        <form
          onSubmit={handleSubmit}
          style={{display: "flex",flexDirection: "column",justifyContent: "center"}}>
          <Box sx={{ textAlign: "center", width: "100%" }}>
            <Box className="statement fs-16 grey-color">
              Enter your email address and we'll send you instructions to reset your password
            </Box>
            <Box sx={{ textAlign: "left", mt: 5 }}>
              <Box component="div">
                <label htmlFor="email"className={errors.email && touched.email ? "error-color" : "label-color"}>
                  Email <span style={{color:'red'}}>*</span>
                </label>
                <TextField
                  sx={{ backgroundColor: "white", mt: 0.5 }}
                  id="email"
                  type="email"
                  fullWidth
                  variant="outlined"
                  error={!!(errors.email && touched.email||error)}
                  value={values.email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        {(errors.email && touched.email)||error ? (
                          <Info fontSize="medium" style={{ color: "red" }} />
                        ) : (
                          <Person fontSize="large" />
                        )}
                      </InputAdornment>
                    ),
                  }}
                />
                {errors.email && touched.email && (
                  <small className="error-color fs-14"> {errors.email} </small>
                )}
                {error && <small className="error-color fs-14">
                   {error}
                  </small>
                }
              </Box>
            </Box>
            <Box sx={{ mt: 6 }}>
              <button type="submit" className="forgot-btn btn-primary cursor-pointer">
                {loadingState ? (
                  <><CircularProgress size={20} sx={{ color: "#FFFFFF", mr: 1 }} />
                    <span>{"  "} Loading...</span></>) : (<span>CONTINUE</span>)}
              </button>
            </Box>
            <Box sx={{ mt: 4 }}>
              <Box
                component="span"
                className={`forgotPass green cursor-pointer`}
                onClick={() => navigate("/authentication/signin")}
                sx={{ color: green[500] }}
              >
                Back to Login
              </Box>
            </Box>
          </Box>
        </form>
      )}
      {!resetPass && (
        <Box className="grey-color" sx={{ lineHeight: "20px", textAlign: "center", mt: 6 }}>
          <p>
            If email address exists, we will immediately send instructions that describe how to
            reset your password.
          </p>
          <p style={{ marginTop: 8 }}>
            Incase you didn't recieve an email kindly check your spam/junk folder.
          </p>
        </Box>
      )}
    </>
  );
};

export default FormInput;
